import React, {FC} from "react"
import styled, {css} from "styled-components"

import Icon, {IconTypes} from "@irati/ui/src/Icon"

interface Props extends CircleProps {}

const TitleIcon: FC<Props> = ({inverted}) => {
  return (
    <Circle inverted={inverted}>
      <Icon icon={IconTypes.piggyBank} size={30} />
    </Circle>
  )
}

export default TitleIcon

interface CircleProps {
  inverted?: boolean
}

const Circle = styled.div<CircleProps>`
  ${({theme, inverted}) => css`
    width: 46px;
    height: 46px;
    padding: ${theme.spacing.one};
    background-color: ${inverted ? theme.colors.greys.grey03 : theme.colors.greys.white};
    border-radius: 100%;
  `}
`
